import { Collections } from "./Collections";

export default function CollectionsPage() {
  return (
    <main data-testid="collections-page" className="pt-20">
      <Collections />
    </main>
  );
}
